import React from "react";
import { Button, Container, Image } from "react-bootstrap";
import ERDiagramProposal from "./images/ERDiagramProposal.png";

const ProposalScreen = () => {
  return (
    <div>
      <Container className="ml-5 mr-5 mt-5 ">
        <div className="d-flex justify-content-center mb-4">
          <Button
            onClick={() =>
              window.open(
                "https://drive.google.com/u/0/uc?id=1c1t1L-w1HrvCgdrAYIEXdMT6ROy2t_sA&export=download"
              )
            }
            variant="outline-danger"
          >
            Click Here to Download PDF
          </Button>
        </div>
        <h2 className="d-flex justify-content-center">
          CS353 PROJECT PROPOSAL
        </h2>
        <h2 className="d-flex justify-content-center">
          GROUP 10 - SYNCODER - ONLINE CODING PLATFORM
        </h2>
        <h3 className="mt-4 d-flex justify-content-center">Members</h3>
        <p className="d-flex justify-content-center">
          ARDA SERİM - 21802554 - SECTION 3
        </p>
        <p className="d-flex justify-content-center">
          FURKAN TURUNÇ - 21802197 - SECTION 3
        </p>
        <p className="d-flex justify-content-center">
          MUHAMMET ABDULLAH KOÇ - 21802832 - SECTION 3
        </p>
        <p className="d-flex justify-content-center">
          MURAT FURKAN UĞURLU - 21802062 - SECTION 3
        </p>
        <Container>
          <div
            style={{
              marginLeft: "10%",
              marginRight: "10%",
              fontSize: "108%",
              textAlign: "justify",
            }}
          >
            <h2>1. Introduction</h2>
            <p>
              The purpose of this proposal is to give a summary about our
              application (Syncoder) which is an online coding platform. In this
              proposal; the description of the project, the purpose of using a
              database, requirements, constraints, and conceptual design of the
              database will be discussed.
            </p>
            <h2 className="mt-5">2. Project Description</h2>
            <p>
              The platform will be a system where users prepare for technical
              job interviews, and companies interview with students. There will
              be users, editors, and companies. Editors prepare both coding
              challenges, coding contests, and non-coding questions. Coding
              contests have several coding challenges. Users will try to solve
              challenges, answer questions and participate in contests. Each
              challenge and question will have a point, and a user can try to
              answer the challenge or question at most 3 times. Companies also
              will be able to prepare a series of coding challenges and
              non-coding questions as a part of their interview process. Coding
              contests can be sponsored by companies with an amount of money.
              Both challenges and questions will have categories. In addition,
              each coding challenge or non-coding question will have difficulty
              level, and users can like / dislike the questions.
            </p>
            <h2 className="mt-5">3. Why / How is a Database Used?</h2>
            <h4 className="mt-3">3.1. Why is a Database Used?</h4>
            <p>
              Our system has a large number of functionalities such as viewing
              challenges, joining contests, attending interviews, liking /
              disliking a question or challenge etc. These functionalities
              require data management, and each data should be stored according
              to their specifications to be used later. Therefore, it is needed
              to group data by their attributes and make relations between them.
              In this context, using a database is strictly required.
            </p>
            <h4 className="mt-3">3.2. How is a Database Used?</h4>
            <p>
              As it was mentioned before, every information will be stored in
              the database as entities and the relations between data will be
              provided by the database. Creating, deleting, updating, accessing
              data will be possible through the database system. We will store
              all users, editors, companies, coding challenges and non-coding
              questions, contests, interviews, and their relation. For instance,
              while adding a new user to the system, a tuple including all
              attributes of the user will be added to the corresponding table in
              the database. Also, to retrieve user information, a query will be
              sent into the database and the necessary data will be provided by
              the database.
            </p>
            <h2 className="mt-5">4. Requirements</h2>
            <h4 className="mt-3">4.1. Functional Requirements</h4>
            <h5 className="mt-3">4.1.1 Admin</h5>
            <ul>
              <li>
                Admin can approve the requests of editors to be registered in
                the application.
              </li>
              <li>
                {" "}
                Admin can approve the requests of the companies to be registered
                in the application.
              </li>
            </ul>
            <h5 className="mt-3">4.1.2 Person</h5>
            <ul>
              <li>
                A person can register with an email, phone number, nickname,
                full name, password, and birth date.
              </li>
              <li> A person can change his/her password.</li>
              <li> A person can change his/her nickname.</li>
              <li> A person can upload his/her photo.</li>
            </ul>
            <h5 className="mt-3">4.1.3 Users</h5>
            <ul>
              <li>
                Users can solve challenges and answer questions within the
                duration of the questions.
              </li>
              <li>Users can participate in interviews.</li>
              <li>Users can participate in contests.</li>
              <li> Users can like or dislike questions.</li>
              <li>
                Users can see both their own statistics and general statistics
                about questions.
              </li>
              <li>
                Users can see which steps they are wrong in the coding
                challenges thanks to test cases of questions.
              </li>
              <li>
                Users can see the top 10 users weekly based on the points they
                collected from non-coding questions and coding challenges.
              </li>
            </ul>
            <h5 className="mt-3">4.1.4 Editors</h5>
            <ul>
              <li>
                Editors can prepare coding challenges by specifying categories.
              </li>
              <li>Editors can prepare coding contests.</li>
              <li>Editors can prepare non-coding questions.</li>
            </ul>
            <h5 className="mt-3">4.1.5 Companies</h5>
            <ul>
              <li>Companies can organize interviews.</li>
              <li>
                Companies can prepare coding challenges and non-coding questions
                for their interview process.
              </li>
              <li>Companies can sponsor contests.</li>
            </ul>
            <h4 className="mt-4">4.2. Non-functional Requirements</h4>
            <h5 className="mt-3">4.2.1 Efficiency</h5>
            <p>
              Our system will make a lot of data addition, retrieval, and
              update. Therefore, the response time of the database should be so
              efficient that users will not experience any unwanted behavior
              from the application. For that purpose, the database should be
              queried in the most efficient way.
            </p>
            <h5 className="mt-3">4.2.1 Usability</h5>
            <p>
              The application will mainly be used by programming enthusiasts and
              interview attendees. Therefore, the user interface should be easy
              to navigate and use the functionalities. Also, because there are
              different coding platforms, our application should attract users
              in order to compete with different applications. The user
              interface is an important point for the attractiveness of the
              application.
            </p>
            <h5 className="mt-3">4.2.3 Robustness</h5>
            <p>
              Because there will be an excessive amount of circulation of the
              data and information between the database system and services, the
              application should not get slower or not give any error. In other
              words, our application should be able to respond to every query
              correctly.
            </p>
            <h5 className="mt-3">4.2.4 Functionality</h5>
            <p>
              The application provides a lot of functionalities for all types of
              users. In order to provide better user experience for all types of
              users and companies, we aim to provide more functions to the
              users. For example, programmers can like / dislike questions and
              see the statistics about questions.
            </p>
            <h5 className="mt-3">4.2.5 Maintainability</h5>
            <p>
              Because we will implement a layered architecture for the
              application, if there are defects in the application, these
              defects can easily be replaced with corrected versions. In
              addition, the application can be updated without damaging other
              parts of the application through the layered structure and the
              well arranged organization of the database. Thus, we will provide
              a maintainable structure for the application.
            </p>
            <h2 className="mt-5">5. Limitations</h2>
            <ul>
              <li>
                A user should not be able to register with an existing email.
              </li>
              <li>A user should be confirmed to use the application.</li>
              <li>
                A user cannot like or dislike a question that is not solved by
                them.
              </li>
              <li>An interview can belong to exactly one company.</li>
              <li>A question can be prepared by only one editor or company.</li>
              <li>An interview should have at least one question.</li>
              <li>
                An editor candidate should submit his/her CV to be approved.
              </li>
              <li>Editors and companies should be approved by an admin.</li>
              <li>An interview can only exist with a company. </li>
              <li>A choice can only exist with a non-coding question. </li>
              <li>Each choice must belong to a single question.</li>
              <li>A contest must be created by at least one editor.</li>
              <li>A contest must include at least one question.</li>
              <li>The existence of test cases depends on coding challenges.</li>
            </ul>
            <h2 className="mt-5">6. Conceptional Design of Database</h2>
            <Image src={ERDiagramProposal} className="w-100"></Image>
          </div>
        </Container>
      </Container>
    </div>
  );
};

export default ProposalScreen;
